// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import DomainProcessNavSwitch from './DomainProcessNavSwitch';

type Props = { process: 'create' | 'renew' | 'transfer' };

export default function DomainPageTitle({
  process,
}: Props): React.MixedElement {
  return (
    <Base flex flexJustifyCenter marginBottom="small">
      <DomainProcessNavSwitch process={process} />
    </Base>
  );
}
